import React, { useState } from "react";
import Card18 from "components/Card18/Card18";
import cogoToast from "cogo-toast";
import { Link, useNavigate } from "react-router-dom";
import { BACKEND_URL } from "constants";
import ReactPaginate from "react-paginate";

const SectionMagazine12 = ({
  posts = [],
  className = "",
}) => {
  const navigate = useNavigate();

  const [itemOffset, setItemOffset] = useState(0);
  const [subcategory, setSubCategory] = useState(1);
  const [category, setCategory] = useState(1);

  const buttonClass =
    "nc-Button flex-shrink-0 relative h-auto inline-flex items-center justify-center rounded-full transition-colors border-transparent text-primary-50 text-sm sm:text-base font-medium py-3 px-4 sm:py-3.5 sm:px-6";

  const sectionNames = {
    1: "Aktualności",
    2: "Aktualności w regionie",
    3: "Wydarzenia dnia",
    4: "Sekcja dwa kwadraty",
    5: "Kwadraty pod menu",
    6: "Bądź na bieżąco",
    7: "Popularne artykuły",
  };

  const filteredPosts = posts.filter(
    (item) =>
      item.category_id === category &&
      item.subcategory_id === subcategory
  );

  const endOffset = itemOffset + 12;
  const currentItems = filteredPosts.slice(itemOffset, endOffset);

  const pageCount = Math.ceil(filteredPosts.length / 12);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * 12) % filteredPosts.length;

    setItemOffset(newOffset);
  };

  const apiRequest = async (
    endpoint,
    method,
    id,
    successMessage,
    options = {}
  ) => {
    try {
      const response = await fetch(
        `${BACKEND_URL}/${endpoint}`,
        {
          method,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id }),
        }
      );

      const data = await response.json();

      if (data.statusCode === 200) {
        cogoToast.success(successMessage);

        if (options.navigateHome) {
          navigate("/");
        }

        if (options.reload) {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const changetoPopular = (id) => {
    setTimeout(() => {
      apiRequest(
        "addtoPopular",
        "PATCH",
        id,
        "Artykuł został dodany do popularnych",
        {
          navigateHome: true,
        }
      );
    }, 2000);
  };

  const onShow = (id) => {
    setTimeout(() => {
      apiRequest(
        "show-articles",
        "PATCH",
        id,
        "Artykuł został odkryty/ukryty",
        {
          reload: true,
        }
      );
    }, 2000);
  };

  const onDelete = (id) => {
    setTimeout(() => {
      apiRequest(
        "delete-articles",
        "POST",
        id,
        "Artykuł został usunięty",
        {
          reload: true,
        }
      );
    }, 2000);
  };

  const onEdit = (id) => {
    navigate(`/edit-articles/${id}`);
  };

  const openArticle = (item) => {
    navigate(
      `/${item?.title?.toLowerCase()}/${
        item?.name === "Świat"
          ? "swiat"
          : item?.name?.toLowerCase()
      }/${item?.category_id}/${
        item?.subcategory_id
      }/artykuł/${item?.id}`
    );
  };

  return (
    <div
      className={`nc-SectionMagazine10 ${className}`}
    >
      {/* Kategorie */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "30px",
        }}
      >
        {subcategory !== 5 && (
          <>
            <button
              style={{
                color:
                  category === 1 ? "red" : "black",
              }}
              onClick={() => {
                setCategory(1);
                setItemOffset(0);
              }}
            >
              Świat
            </button>

            <button
              style={{
                color:
                  category === 3 ? "red" : "black",
              }}
              onClick={() => {
                setCategory(3);
                setItemOffset(0);
              }}
            >
              Kraj
            </button>
          </>
        )}

        <button
          style={{
            color:
              category === 5 ? "red" : "black",
          }}
          onClick={() => {
            setCategory(5);
            setItemOffset(0);
          }}
        >
          Region
        </button>
           <button
          style={{
            color:
              category === 8 ? "red" : "black",
          }}
          onClick={() => {
            setCategory(8);
            setItemOffset(0);
          }}
        >
          Zdrowie
        </button>
      </div>

      {/* Podkategorie */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "30px",
        }}
      >
        {category === 1 && (
          <>
            <button
              style={{
                color:
                  subcategory === 1
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(1)}
            >
              Gospodarka
            </button>

            <button
              style={{
                color:
                  subcategory === 2
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(2)}
            >
              Polityka
            </button>

            <button
              style={{
                color:
                  subcategory === 3
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(3)}
            >
              Społeczeństwo
            </button>

            <button
              style={{
                color:
                  subcategory === 17
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(17)}
            >
              Konflikty
            </button>

            <button
              style={{
                color:
                  subcategory === 10
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(10)}
            >
              Bezpieczeństwo
            </button>
          </>
        )}

        {category === 3 && (
          <>
            <button
              style={{
                color:
                  subcategory === 1
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(1)}
            >
              Gospodarka
            </button>

            <button
              style={{
                color:
                  subcategory === 2
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(2)}
            >
              Polityka
            </button>

            <button
              style={{
                color:
                  subcategory === 3
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(3)}
            >
              Społeczeństwo
            </button>

            <button
              style={{
                color:
                  subcategory === 9
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(9)}
            >
              Prawo
            </button>

            <button
              style={{
                color:
                  subcategory === 10
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(10)}
            >
              Bezpieczeństwo
            </button>
          </>
        )}

        {category === 5 && (
          <>
            <button
              style={{
                color:
                  subcategory === 1
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(1)}
            >
              Gospodarka
            </button>

            <button
              style={{
                color:
                  subcategory === 2
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(2)}
            >
              Polityka
            </button>

            <button
              style={{
                color:
                  subcategory === 3
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(3)}
            >
              Społeczeństwo
            </button>

            <button
              style={{
                color:
                  subcategory === 4
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(4)}
            >
              Sport
            </button>

            <button
              style={{
                color:
                  subcategory === 5
                    ? "red"
                    : "black",
              }}
              onClick={() => setSubCategory(5)}
            >
              Aktualności
            </button>
          </>
        )}

        {category === 6 && (
          <button
            style={{
              color:
                subcategory === 5
                  ? "red"
                  : "black",
            }}
            onClick={() => setSubCategory(5)}
          >
            Aktualności
          </button>
        )}
        {category === 8 && (
          <>
          <button
            style={{
              color:
                subcategory === 11
                  ? "red"
                  : "black",
            }}
            onClick={() => setSubCategory(11)}
          >
            Profilaktyka
          </button>
          <button
            style={{
              color:
                subcategory === 12
                  ? "red"
                  : "black",
            }}
            onClick={() => setSubCategory(12)}
          >
            Choroby
          </button>
           <button
            style={{
              color:
                subcategory === 13
                  ? "red"
                  : "black",
            }}
            onClick={() => setSubCategory(13)}
          >
            Zdrowie psychiczne
          </button>
           <button
            style={{
              color:
                subcategory === 14
                  ? "red"
                  : "black",
            }}
            onClick={() => setSubCategory(14)}
          >
            Medycyna
          </button>
           <button
            style={{
              color:
                subcategory === 15
                  ? "red"
                  : "black",
            }}
            onClick={() => setSubCategory(15)}
          >
            System ochrony zdrowia
          </button>
          <button
            style={{
              color:
                subcategory === 16
                  ? "red"
                  : "black",
            }}
            onClick={() => setSubCategory(16)}
          >
            Przepisy
          </button>
          </>
        )}
      </div>

      {!filteredPosts.length && (
        <span>Nic nie znaleziono!</span>
      )}

      <div className="grid grid-cols-1 xl:grid-cols-4 gap-5">
        {currentItems.map((item) => (
          <div
            style={{
              display: "flex",
              flexFlow: "column",
            }}
            key={item.id}
          >
            <h3
              style={{
                marginBottom: "20px",
                fontSize: "20px",
              }}
            >
              {item.article_title}
            </h3>

            <Card18
              imgClassName="max-height-220"
              post={item}
            />

            <span
              style={{
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "bold",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              {sectionNames[item.section_id] || ""}
            </span>

            <div
              style={{
                display: "flex",
                flexFlow: "column",
                justifyContent:
                  "space-between",
              }}
            >
              <button
                onClick={() =>
                  onDelete(item.id)
                }
                className={buttonClass}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  backgroundColor: "red",
                }}
              >
                Usuń artykuł
              </button>

              <button
                onClick={() =>
                  onEdit(item.id)
                }
                className={buttonClass}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  backgroundColor: "blue",
                }}
              >
                Edytuj artykuł
              </button>

              <button
                onClick={() =>
                  openArticle(item)
                }
                className={buttonClass}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  backgroundColor: "orange",
                }}
              >
                Zobacz artykuł
              </button>

              <button
                onClick={() =>
                  changetoPopular(item.id)
                }
                className={buttonClass}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  backgroundColor: "green",
                }}
              >
                Dodaj do popularnych
              </button>

              <button
                onClick={() =>
                  onShow(item.id)
                }
                className={buttonClass}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  backgroundColor: "black",
                }}
              >
                {item.status === 0
                  ? "Pokaż artykuł"
                  : "Ukryj artykuł"}
              </button>
              <button
  onClick={() => {
     navigator.clipboard.writeText(
      `https://respublica-backend.onrender.com/post/${item.id}`
    )
    cogoToast.info("Link został skopiowany")
  }}
  className={buttonClass}
  style={{
    marginTop: "10px",
    backgroundColor: "#6b7280",
  }}
>
  Kopiuj link do udostępnienia
</button>
            </div>
          </div>
        ))}
      </div>

      {!!pageCount && (
        <div
          style={{
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <ReactPaginate
            nextLabel="następna >"
            previousLabel="< poprzednia"
            breakLabel="..."
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </div>
      )}
    </div>
  );
};

export default SectionMagazine12;